import {AppActions} from "../app/AppActions";
import {Observable, of} from "rxjs";
import {combineEpics, PledgerAction, PledgerEpic} from "@pledger/frontend-commons";


const emptyEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) => of(AppActions.EMPTY_ACTION.build());

/*const homeLoadedLoadedEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) =>
    actions$.pipe(
        ofType(PressActions.HOME_LOADED_ACTION.type),
        map((action) => {
            return WServiceActions.GET_SELFCARE_REFERENCES_ACTION.build();
        })
    );*/




export const homeEpics = combineEpics(
    emptyEpic
);

